import axios from "axios";

export default axios.create({ baseURL: "https://api.cilia.co.id/api" });
